import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

/**
 * Validates if a phone number is valid and starts with "+" or "00"
 * @param phoneNumber - The phone number string to validate
 * @returns boolean - True if the phone number is valid and starts with "+" or "00", false otherwise
 */
export const isValidIntPhoneNumber = (phoneNumber: string): boolean => {
  if (!phoneNumber || typeof phoneNumber !== 'string') {
    return false;
  }

  // Trim whitespace
  const trimmedNumber = phoneNumber.trim();

  let formattedNumber: string;

  // Check if the number starts with "+" or "00"
  if (trimmedNumber.startsWith('+')) {
    // Number already starts with "+"
    if (trimmedNumber.length < 4) {
      // At least "+123"
      return false;
    }

    // Check if the rest contains only digits
    const numberPart = trimmedNumber.slice(1); // Remove "+" prefix
    if (!/^\d+$/.test(numberPart)) {
      return false;
    }

    formattedNumber = trimmedNumber;
  } else if (trimmedNumber.startsWith('00')) {
    // Number starts with "00"
    if (trimmedNumber.length < 5) {
      // At least "00123"
      return false;
    }

    // Check if the rest contains only digits
    const numberPart = trimmedNumber.slice(2); // Remove "00" prefix
    if (!/^\d+$/.test(numberPart)) {
      return false;
    }

    // Convert "00" to "+" for libphonenumber-js parsing
    formattedNumber = `+${numberPart}`;
  } else {
    // Number doesn't start with "+" or "00"
    return false;
  }

  // Use libphonenumber-js for validation
  try {
    const parsedNumber = parsePhoneNumberFromString(formattedNumber);
    return parsedNumber ? parsedNumber.isValid() : false;
  } catch (error) {
    return false;
  }
};
